import { RouteRecordRaw } from 'vue-router'
import { prefixLanguage } from '@utils/urls';
import type { Options } from '@/router'
import { prefixRoutes } from '@router/utils'

import { createRoutes as createCabinetRoutes } from '@app/pages/cabinet/router'

export default function createInitialRoutes(options: Options): RouteRecordRaw[] {
  return [
    prefixRoutes(prefixLanguage('/cabinet/'), createCabinetRoutes(options),
    {
      meta: { requiresAuth: true }
    }
    )
  ]
}

